import { useMutation } from 'react-query';

import { EstimateTaxCalculationParams, estimateTaxCalculation } from '@utils/backend-api/stripe';

export default function useEstimateTaxCalculation() {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: EstimateTaxCalculationParams) => estimateTaxCalculation(params)
  );
  return { mutate, mutateAsync, isLoading, isError };
}
